<template>
  <div v-loading="loading" class="standardDto">
    <div class="standardDto-basic">
      <com-dto-data1
        :list="standardInfo.obj.basics1"
        :obj="dtoObj" />
      <com-dto-data2
        :list1="btns1"
        :list2="standardInfo.obj.basics2"
        :obj="dtoObj"
        @control="handleControl1"
        @status11="handleStatus11"
        @status10="handleStatus10"
      />
    </div>
    <div class="standardDto-img">
      <com-dto-side1 :obj="dtoObj" />
    </div>
    <div class="standardDto-content">
      <com-dto-data3 :obj="dtoObj" />
    </div>
    <div class="standardDto-idea">
      <com-layout1
        title="相关标准"
        :total="total2"
        :page="requestParams2.page"
        :list="list2"
        basic-type="2"
        basic-width="122px"
        @currentChange="handleCurrentChange2"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api/app'
import mock from '@/utils/mock'
import comDtoData1 from './comDtoData1.vue'
import comDtoData2 from './comDtoData2.vue'
import comDtoData3 from './comDtoData3.vue'
import comDtoSide1 from './comDtoSide1.vue'
import comLayout1 from '@/components/layout/comLayout1'
export default {
  components: {
    comDtoData1,
    comDtoData2,
    comDtoData3,
    comDtoSide1,
    comLayout1
  },
  props: {
    rowId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      standardInfo: mock.notes.standard.viewInfo,
      standardInit: mock.notes.standard.init,
      btns1: mock.notes.standard.viewInfo.obj.btns1,
      is_collection: false,
      requestParams1: {
        id: null
      },
      dtoObj: null,

      list2: null,
      total2: 100,
      requestParams2: {
        page: 1,
        page_size: 10,
        id: null
      },
      requestParams4: {
        collection_id: null,
        collection_type: 1
      },
      loading: true
    }
  },
  computed: {},
  watch: {
    $route: {
      handler(v) {
        this.init(v.query.id)
      }
    },
    deep: true
  },
  created() {
    const id = this.rowId || this.$route.query.id
    this.init(id)
  },
  mounted() {},
  methods: {
    init(v) {
      this.requestParams1.id = v
      this.requestParams2.id = v
      this.requestParams4.collection_id = v
      this.initDto(this.requestParams1)
      this.initAbout1(this.requestParams2)
    },
    async initDto(v) {
      this.dtoObj = await this.standardInit.dto(v)
      this.is_collection = this.dtoObj.is_collection == 1
      this.btns1.map((item) => {
        if (item.model == 'evaluate') {
          item.status = this.is_collection ? 2 : 0
        }
      })
      this.loading = false
    },
    async initAbout1(v) {
      const obj = await this.standardInit.about1(v)
      this.list2 = obj.data
      this.total2 = obj.total
      this.loading = false
    },
    handleCurrentChange2(val) {
      this.requestParams2.page = val
      this.initAbout1(this.requestParams2)
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    handleRouteDto(v) {
      this.$router.push({
        path: '/notes/standard/details',
        query: {
          id: v
        }
      })
    },
    handleStatus10(v) {
      this.btns1.map((item, index) => {
        if (v == index) {
          if (item.status == 1) {
            item.status = 0
          }
        }
      })
    },
    handleStatus11(v) {
      this.btns1.map((item, index) => {
        if (v == index) {
          if (item.status == 0) {
            item.status = 1
          }
        }
      })
    },
    handleControl1(v) {
      if (v == 'evaluate') {
        if (this.is_collection) {
          this.$confirm('确认取消收藏吗?', '提示', {})
            .then(() => {
              api.mine.delete.collect(this.requestParams4).then((res) => {
                this.$message.success('取消收藏成功')
                // this.init(this.$route.query.id)
                this.btns1.map((item) => {
                  if (item.model == 'evaluate') {
                    item.status = 0
                  }
                })
                this.is_collection = !this.is_collection
              })
            })
            .catch(() => {})
        } else {
          this.$confirm('确认收藏吗?', '提示', {})
            .then(() => {
              api.mine.create.collect(this.requestParams4).then((res) => {
                this.$message.success('收藏成功')
                // this.init(this.$route.query.id)
                this.btns1.map((item) => {
                  if (item.model == 'evaluate') {
                    item.status = 2
                  }
                })
                this.is_collection = !this.is_collection
              })
            })
            .catch(() => {})
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.standardDto {
  @include fun-layout(1);
  display: flex;
  overflow: hidden;
  background-color: #f6f6f6;
  padding: 20px 34px 10px 34px;
  display: flex;
  flex-wrap: wrap;
  min-height: 100%;
  > div {
    @include fun-layout(2);
  }
  &-basic {
    height: 180px;
    width: calc(85% - 20px);
    margin-right: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    padding: 20px;
    display: flex;
    flex-direction: column;
    > section {
      width: 100%;
      &:nth-child(1) {
        height: 66%;
      }
      &:nth-child(2) {
        flex: 1;
      }
    }
  }
  &-img {
    height: 180px;
    width: 15%;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  &-content {
    // height: 1146px;
    width: calc(85% - 20px);
    margin-right: 20px;
  }
  &-idea {
    // height: 1146px;
    width: 15%;
  }
}
</style>
